var map = {
	"./bol-16.png": 73447,
	"./bol-fav-32.png": 27297,
	"./connect-api.png": 98509,
	"./connect-api.webp": 16484,
	"./data-rows.png": 90418,
	"./data-rows.webp": 13583,
	"./dave-levi.png": 40048,
	"./dave-levi.webp": 3352,
	"./empty-dashboard.png": 86039,
	"./empty-dashboard.webp": 53552,
	"./logo-no-text-big.png": 824,
	"./logo-no-text-big.webp": 36358,
	"./logo-no-text-gray.png": 22873,
	"./logo-no-text-gray.webp": 18450,
	"./logo-no-text.png": 42468,
	"./logo-no-text.webp": 90183,
	"./logo.png": 40627,
	"./logo.webp": 43875,
	"./logos-companies.png": 98945,
	"./logos-companies.webp": 88130,
	"./registrationBG.png": 67636,
	"./registrationBG.webp": 31948,
	"./rocket-2.png": 35846,
	"./rocket-2.webp": 33163,
	"./search-ranking.png": 4604,
	"./star-gold.png": 62693,
	"./star-gold.svg": 17870,
	"./star-gray.png": 27655,
	"./star-gray.svg": 93754,
	"./trial-rocket.png": 64281,
	"./trial-rocket.webp": 14299,
	"./trustpilot.png": 42590,
	"./trustpilot.webp": 15115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46138;